var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloatingUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.318 13.731a1 1 0 001.45-1.37l-.086-.092-7.5-7a1 1 0 00-1.264-.082l-.1.082-7.5 7a1 1 0 001.267 1.541l.097-.08L9.5 7.37l6.818 6.362z",
    fill: "var(--icon-dark-gray)",
    fillRule: "nonzero"
  }))));
}
export default SvgFloatingUpArrow;